/* Furniva — shop by need (sections/furniva-category-index.liquid).

   The needs are tabs; each answer is already in the page. Choosing a need —
   pointing at it for a moment, clicking it, or moving with the arrow keys —
   shows its answer, which fades up in place. A click on the need that is
   already showing follows its link, so the list still works as navigation.
   Without this script the first answer shows and every need is a link. */
(function () {
  'use strict';

  document.querySelectorAll('[data-fv-needs]').forEach(function (root) {
    if (root.dataset.fvNeedsReady === '1') return;
    root.dataset.fvNeedsReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fv-need-tab]'));
    if (tabs.length < 2) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // The answers not showing yet hold lazy pictures, which a hidden panel
    // never starts — so the first switch showed empty squares. Once the page
    // has settled, ask for all of them (a few small squares each).
    var warm = function () {
      root.querySelectorAll('[data-fv-need-panel] img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 2500 });
    else setTimeout(warm, 1500);
    var hoverTimer = null;

    function current() {
      for (var i = 0; i < tabs.length; i++) if (tabs[i].getAttribute('aria-selected') === 'true') return tabs[i];
      return tabs[0];
    }

    function show(tab, focus) {
      var was = current();
      if (tab === was) return;
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (!panel) return;
        if (on) {
          panel.hidden = false;
          if (!still) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        } else {
          panel.hidden = true;
          panel.classList.remove('is-entering');
        }
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        if (tab !== current()) {
          event.preventDefault();
          show(tab, false);
        }
      });
      tab.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { show(tab, false); }, 120);
      });
      tab.addEventListener('pointerleave', function () { clearTimeout(hoverTimer); });
      tab.addEventListener('keydown', function (event) {
        var to = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') to = tabs[(i + 1) % tabs.length];
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') to = tabs[(i - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') to = tabs[0];
        if (event.key === 'End') to = tabs[tabs.length - 1];
        if (!to) return;
        event.preventDefault();
        show(to, true);
      });
    });
  });
})();
